import { useMemo } from 'react';
import { Frequency } from '../../components/manageMentorship/types/frequency';
import { RepeatMonthlyStrategy } from '../../components/manageMentorship/types/repeatMonthlyStrategy';
import { RepeatStrategy } from '../../components/manageMentorship/types/repeatStrategy';
function formatTime(hours) {
    return `${hours.toString().padStart(2, '0')}:00`;
}
function getDefaultDateTime() {
    const now = new Date();
    now.setHours(now.getHours() + 1, 0, 0, 0);
    return {
        date: now,
        startTime: formatTime(now.getHours()),
        endTime: formatTime(now.getHours() + 1)
    };
}
export function useMentorshipDefaultValues() {
    const { date, startTime, endTime } = getDefaultDateTime();
    const defaultValues = useMemo(() => ({
        classes: [],
        mediaId: null,
        imageId: null,
        coverImageId: null,
        cover: null,
        date,
        recurringSession: {
            isRecurrent: false,
            frequency: Frequency.Daily,
            repeat: {
                every: '1',
                strategy: RepeatStrategy.Daily,
                monthlyStrategy: RepeatMonthlyStrategy.OnDay,
                weeklyStrategy: []
            }
        },
        startTime,
        endTime
    }), [date, startTime, endTime]);
    return defaultValues;
}
